import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, createBlock as _createBlock, createVNode as _createVNode, Fragment as _Fragment, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = {
  key: 1,
  class: "vac-avatar-offset"
}
const _hoisted_3 = {
  class: /*#__PURE__*/_normalizeClass(`text-primary`)
}
const _hoisted_4 = { key: 3 }
const _hoisted_5 = {
  key: 0,
  class: "vac-progress-time"
}
const _hoisted_6 = { class: "vac-text-timestamp" }
const _hoisted_7 = {
  key: 0,
  class: "vac-icon-edited"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-clock pl-1" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "vac-failure-text" }, "!", -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 3,
  class: "vac-avatar-current-offset"
}

import { computed, onMounted, reactive, ref } from "vue";
import { isAudioFile } from "vue-advanced-chat/src/utils/media-file.js";
import {
	Message,
	MessageActions as IMessageActions,
	MessageFile,
	Messages,
	TextFormatting,
	UsernameOptions,
} from "vue-advanced-chat";
import SvgIcon from "vue-advanced-chat/src/components/SvgIcon/SvgIcon.vue";
import FormatMessage from "vue-advanced-chat/src/components/FormatMessage/FormatMessage.vue";
import AudioPlayer from "vue-advanced-chat/src/lib/Room/RoomMessage/AudioPlayer/AudioPlayer.vue";
import MessageReply from "vue-advanced-chat/src/lib/Room/RoomMessage/MessageReply/MessageReply.vue";
import MessageFiles from "./MessageFiles.vue";
import MessageActions from "vue-advanced-chat/src/lib/Room/RoomMessage/MessageActions/MessageActions.vue";
import MessageReactions from "vue-advanced-chat/src/lib/Room/RoomMessage/MessageReactions/MessageReactions.vue";
import MessageCards from "./MessageCards.vue";
import MessageMail from "./MessageMail.vue";

type MessageProps = {
	message: Message;
	currentUserId: string | number;
	textMessages?: Record<string, string | number>;
	messages: Messages;
	editedMessageId?: string | number;
	roomUsers: { [k: string]: { _id: string; color?: string; username: string } };
	messageActions?: IMessageActions;
	newMessages: Messages;
	showReactionEmojis: boolean;
	showNewMessagesDivider: boolean;
	textFormatting?: TextFormatting;
	usernameOptions?: UsernameOptions;
	linkOptions?: {
		disabled: false;
		target: string;
		rel: unknown;
	};
	messageSelectionEnabled?: boolean;
	selectedMessages?: Messages;
};

export default /*#__PURE__*/_defineComponent({
  props: {
    message: null,
    currentUserId: null,
    textMessages: null,
    messages: null,
    editedMessageId: null,
    roomUsers: null,
    messageActions: { default: () => [
		{ name: "replyMessage", title: "Reply" },
		{ name: "editMessage", title: "Edit Message", onlyMe: true },
		{ name: "deleteMessage", title: "Delete Message", onlyMe: true },
		{ name: "selectMessages", title: "Select" },
	] },
    newMessages: null,
    showReactionEmojis: { type: Boolean },
    showNewMessagesDivider: { type: Boolean },
    textFormatting: { default: () => ({
		disabled: false,
		italic: "_",
		bold: "*",
		strike: "~",
		underline: "°",
		multilineCode: "```",
		inlineCode: "`",
	}) },
    usernameOptions: { default: () => ({ minUsers: 3, currentUser: false }) },
    linkOptions: { default: () => ({ disabled: false, target: "_blank", rel: null }) },
    messageSelectionEnabled: { type: Boolean, default: false },
    selectedMessages: { default: () => [] }
  },
  emits: [
	"message-added",
	"open-file",
	"download-file",
	"open-user-tag",
	"open-failed-message",
	"message-action-handler",
	"send-message-reaction",
	"select-message",
	"unselect-message",
],
  setup(__props: any, { emit: emits }) {

const props = __props as { message: Message, currentUserId: string | number, textMessages?: Record<string, string | number>, messages: Messages, editedMessageId?: string | number, roomUsers: { [k: string]: { _id: string; color?: string; username: string } }, messageActions: IMessageActions, newMessages: Messages, showReactionEmojis: boolean, showNewMessagesDivider: boolean, textFormatting: TextFormatting, usernameOptions: UsernameOptions, linkOptions: {
		disabled: false;
		target: string;
		rel: unknown;
	}, messageSelectionEnabled: boolean, selectedMessages: Messages }

const rightMessageOrigins = ["supervisor", "bot"];
const customTypes = ["buttons", "cards"];

const data = reactive<{
	hoverMessageId: string | number | null;
	messageHover: boolean;
	optionsOpened: boolean;
	emojiOpened: boolean;
	newMessage: Message | null;
	progressTime: string;
	hoverAudioProgress: boolean;
}>({
	hoverMessageId: null,
	messageHover: false,
	optionsOpened: false,
	emojiOpened: false,
	newMessage: null,
	progressTime: "- : -",
	hoverAudioProgress: false,
});
const videoEl = ref<HTMLVideoElement | null>(null);
const playing = ref<boolean>(false);

const showUsername = computed(() => {
	if (
		!props.usernameOptions.currentUser &&
		props.message.senderId === props.currentUserId
	) {
		return false;
	} else {
		return (
			Object.keys(props.roomUsers).length >= props.usernameOptions.minUsers
		);
	}
});
const messageOffset = computed(() => {
	return (
		index.value > 0 &&
		props.message.senderId !== props.messages[index.value - 1].senderId
	);
});
const isMessageHover = computed(() => {
	return (
		props.editedMessageId === props.message._id ||
		data.hoverMessageId === props.message._id
	);
});
const isAudio = computed(() => {
	return props.message.files?.some(file => isAudioFile(file));
});
const isCheckmarkVisible = computed(() => {
	return (
		(props.message.senderId === props.currentUserId ||
			rightMessageOrigins.includes(props.message.origin ?? "")) &&
		!props.message.deleted &&
		(props.message.saved || props.message.distributed || props.message.seen)
	);
});
const hasCurrentUserAvatar = computed(() => {
	return props.messages.some(
		message => message.senderId === props.currentUserId && message.avatar
	);
});
const hasSenderUserAvatar = computed(() => {
	return props.messages.some(
		message => message.senderId !== props.currentUserId && message.avatar
	);
});
const isMessageSelected = computed(() => {
	return (
		props.messageSelectionEnabled &&
		!!props.selectedMessages.find(message => message._id === props.message._id)
	);
});

const isGif = computed(() => {
	return /gif/i.test(props.message.files?.[0]?.url ?? "");
});
const showTagGif = computed(() => {
	return isGif.value && !playing.value;
});



/* function goToReply(e: any) {
	message
} */
function formatName(name: string): string {
	return name[0].toUpperCase() + name.slice(1).toLowerCase();
}
function onHoverMessage() {
	if (!props.messageSelectionEnabled) {
		data.messageHover = true;
		if (canEditMessage()) data.hoverMessageId = props.message._id;
	}
}
function canEditMessage() {
	return !props.message.deleted;
}
const index = computed<number>(() =>
	parseInt(props.message.indexId.toString())
);
function onLeaveMessage() {
	if (!props.messageSelectionEnabled) {
		if (!data.optionsOpened && !data.emojiOpened) data.messageHover = false;
		data.hoverMessageId = null;
	}
}
function resetMessageHover() {
	data.messageHover = false;
	data.hoverMessageId = null;
}
function openFile({ file, action }: { file: MessageFile; action: string }) {
	if (action === "preview") {
		if (isGif.value) {
			playing.value = !!videoEl.value?.paused;
			videoEl.value?.[videoEl.value?.paused ? "play" : "pause"]();
		} else {
			emits("open-file", { message: props.message, file: file, action });
		}
	} else if (action === "download") {
		if ((file.type === "file" || file.type === "unknown") && file.url) {
			let filelink = document.createElement("a");
			filelink.href = file.url;
			filelink.setAttribute(
				"download",
				`${file.name.split(".").shift()}.${file.url
					?.split("/")
					.pop()
					?.split(".")
					.pop()}`
			);
			filelink.setAttribute("target", "_blank");
			document.body.appendChild(filelink);
			filelink.click();
			document.body.removeChild(filelink);
		}
	}
}
function downloadFile({ file, action }: { file: MessageFile; action: string }) {
	emits("download-file", { message: props.message, file: file, action });
	if (file && file.url) {
		let filelink = document.createElement("a");
		filelink.href = file.url;
		filelink.setAttribute(
			"download",
			`${file.name.split(".").shift()}.${file.url
				?.split("/")
				.pop()
				?.split(".")
				.pop()}`
		);
		filelink.setAttribute("target", "_blank");
		document.body.appendChild(filelink);
		filelink.click();
		document.body.removeChild(filelink);
	}
}
function openUserTag(user: unknown) {
	emits("open-user-tag", { user });
}
function messageActionHandler(action: unknown) {
	resetMessageHover();

	setTimeout(() => {
		emits("message-action-handler", { action, message: props.message });
	}, 300);
}
function sendMessageReaction({
	emoji,
	reaction,
}: {
	emoji: unknown;
	reaction: unknown[];
}) {
	emits("send-message-reaction", {
		messageId: props.message._id,
		reaction: emoji,
		remove: reaction && reaction.indexOf(props.currentUserId) !== -1,
	});
	data.messageHover = false;
}
onMounted(() => {
	const mId = props.message._id;
	if (props.message.files && isGif.value) {
		const videoControl: HTMLVideoElement = document
			.getElementById(mId.toString())
			?.getElementsByTagName("video")[0] as HTMLVideoElement;
		if (videoControl) {
			videoControl.controls = false;
			videoControl.loop = true;
			videoEl.value = videoControl;
		}
	}
});

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["vac-message-box", {
				'vac-offset-current':
					__props.message.senderId === __props.currentUserId ||
					rightMessageOrigins.includes(__props.message.origin ?? '') ||
					__props.message.origin === 'agent',
				'w-50': _unref(isAudio),
				'vac-audio-box': _unref(isAudio),
			}])
    }, [
      (__props.message.avatar && __props.message.senderId !== __props.currentUserId)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "vac-avatar",
            style: _normalizeStyle({ 'background-image': `url('${__props.message.avatar}')` })
          }, null, 4))
        : _createCommentVNode("", true),
      (_unref(hasSenderUserAvatar) && !__props.message.avatar)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["vac-message-container", {
					'vac-message-container-offset': _unref(messageOffset),
					'vac-message-container-first': __props.message.isFirst,
					'has-failure': !!__props.message.failure,
					'w-100': _unref(isAudio),
				}])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["vac-message-card", {
						'vac-message-highlight': _unref(isMessageHover),
						'vac-message-current':
							__props.message.senderId === __props.currentUserId ||
							rightMessageOrigins.includes(__props.message.origin ?? ''),
						'vac-message-agent':
							__props.message.senderId !== __props.currentUserId && __props.message.origin === 'agent',
						'vac-message-deleted': __props.message.deleted,
						'vac-item-clickable': __props.messageSelectionEnabled,
						'vac-message-selected': _unref(isMessageSelected),
						'vac-message-first': __props.message.isFirst,
					}]),
          onMouseover: onHoverMessage,
          onMouseleave: onLeaveMessage
        }, [
          (_unref(showUsername) && __props.message.senderId !== __props.currentUserId)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["vac-text-username", {
							'vac-username-reply': !__props.message.deleted && __props.message.replyMessage,
						}])
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(`text-${__props.roomUsers[__props.message.senderId].color}`)
                }, _toDisplayString(__props.message.username), 3)
              ], 2))
            : (rightMessageOrigins.includes(__props.message.origin ?? ''))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(["vac-text-username", {
							'vac-username-reply': !__props.message.deleted && __props.message.replyMessage,
						}])
                }, [
                  _createElementVNode("span", _hoisted_3, _toDisplayString(formatName(__props.message.origin ?? "")), 1)
                ], 2))
              : _createCommentVNode("", true),
          (!__props.message.deleted && __props.message.replyMessage)
            ? (_openBlock(), _createBlock(MessageReply, {
                key: 2,
                onClick: _cache[0] || (_cache[0] = () => messageActionHandler({ name: 'go-to-reply' })),
                message: __props.message,
                "room-users": Object.values(__props.roomUsers),
                "text-formatting": __props.textFormatting,
                "link-options": __props.linkOptions
              }, _createSlots({ _: 2 }, [
                _renderList(_ctx.$slots, (i, name) => {
                  return {
                    name: name,
                    fn: _withCtx((data) => [
                      _renderSlot(_ctx.$slots, name, _normalizeProps(_guardReactiveProps(data)))
                    ])
                  }
                })
              ]), 1032, ["message", "room-users", "text-formatting", "link-options"]))
            : _createCommentVNode("", true),
          (__props.message.deleted)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _renderSlot(_ctx.$slots, "deleted-icon", {}, () => [
                  _createVNode(SvgIcon, {
                    name: "deleted",
                    class: "vac-icon-deleted"
                  })
                ]),
                _createElementVNode("span", null, _toDisplayString(__props.textMessages?.MESSAGE_DELETED), 1)
              ]))
            : (!__props.message.files || !__props.message.files.length)
              ? (_openBlock(), _createBlock(FormatMessage, {
                  key: 4,
                  content: __props.message.content,
                  users: Object.keys(__props.roomUsers),
                  "text-formatting": __props.textFormatting,
                  "link-options": __props.linkOptions,
                  onOpenUserTag: openUserTag
                }, _createSlots({ _: 2 }, [
                  _renderList(_ctx.$slots, (i, name) => {
                    return {
                      name: name,
                      fn: _withCtx((data) => [
                        _renderSlot(_ctx.$slots, name, _normalizeProps(_guardReactiveProps(data)))
                      ])
                    }
                  })
                ]), 1032, ["content", "users", "text-formatting", "link-options"]))
              : (
							__props.message.files && customTypes.includes(__props.message.files[0].type)
						)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                    _createVNode(FormatMessage, {
                      content: __props.message.content,
                      users: Object.keys(__props.roomUsers),
                      "text-formatting": __props.textFormatting,
                      "link-options": __props.linkOptions,
                      onOpenUserTag: openUserTag
                    }, _createSlots({ _: 2 }, [
                      _renderList(_ctx.$slots, (i, name) => {
                        return {
                          name: name,
                          fn: _withCtx((data) => [
                            _renderSlot(_ctx.$slots, name, _normalizeProps(_guardReactiveProps(data)))
                          ])
                        }
                      })
                    ]), 1032, ["content", "users", "text-formatting", "link-options"]),
                    _createVNode(MessageCards, {
                      name: __props.message.files[0].name,
                      buttons: __props.message.files[0].buttons ?? undefined,
                      cards: __props.message.files[0].cards ?? undefined
                    }, null, 8, ["name", "buttons", "cards"])
                  ], 64))
                : (
							__props.message.files && __props.message.files[0].name === 'email-formatting'
						)
                  ? (_openBlock(), _createBlock(MessageMail, {
                      key: 6,
                      content: __props.message.content,
                      "room-users": Object.keys(__props.roomUsers),
                      "text-formatting": __props.textFormatting,
                      "link-options": __props.linkOptions,
                      files: __props.message.files[0].cards ?? [],
                      onOpenFile: openFile,
                      onDownloadFile: downloadFile
                    }, null, 8, ["content", "room-users", "text-formatting", "link-options", "files"]))
                  : (!_unref(isAudio) || __props.message.files.length > 1)
                    ? (_openBlock(), _createBlock(MessageFiles, {
                        key: 7,
                        "current-user-id": __props.currentUserId,
                        message: __props.message,
                        "room-users": Object.keys(__props.roomUsers),
                        "text-formatting": __props.textFormatting,
                        "link-options": __props.linkOptions,
                        "message-selection-enabled": __props.messageSelectionEnabled,
                        onOpenFile: openFile,
                        onDownloadFile: downloadFile,
                        class: _normalizeClass({
							'vac-message-gif': _unref(showTagGif),
						})
                      }, _createSlots({ _: 2 }, [
                        _renderList(_ctx.$slots, (i, name) => {
                          return {
                            name: name,
                            fn: _withCtx((data) => [
                              _renderSlot(_ctx.$slots, name, _normalizeProps(_guardReactiveProps(data)))
                            ])
                          }
                        })
                      ]), 1032, ["current-user-id", "message", "room-users", "text-formatting", "link-options", "message-selection-enabled", "class"]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                        _createVNode(AudioPlayer, {
                          "message-id": __props.message._id,
                          src: __props.message.files[0].url,
                          "message-selection-enabled": __props.messageSelectionEnabled,
                          onUpdateProgressTime: _cache[1] || (_cache[1] = ($event: any) => (_unref(data).progressTime = $event)),
                          onHoverAudioProgress: _cache[2] || (_cache[2] = ($event: any) => (_unref(data).hoverAudioProgress = $event))
                        }, _createSlots({ _: 2 }, [
                          _renderList(_ctx.$slots, (i, name) => {
                            return {
                              name: name,
                              fn: _withCtx((data) => [
                                _renderSlot(_ctx.$slots, name, _normalizeProps(_guardReactiveProps(data)))
                              ])
                            }
                          })
                        ]), 1032, ["message-id", "src", "message-selection-enabled"]),
                        (!__props.message.deleted)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(data).progressTime), 1))
                          : _createCommentVNode("", true)
                      ], 64)),
          _createElementVNode("div", _hoisted_6, [
            (__props.message.edited && !__props.message.deleted)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _renderSlot(_ctx.$slots, "pencil-icon", {}, () => [
                    _createVNode(SvgIcon, { name: "pencil" })
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("span", null, _toDisplayString(__props.message.timestamp), 1),
            (_unref(isCheckmarkVisible))
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                  _renderSlot(_ctx.$slots, "checkmark-icon", _normalizeProps(_guardReactiveProps({ message: __props.message })), () => [
                    _createVNode(SvgIcon, {
                      name: __props.message.distributed ? 'double-checkmark' : 'checkmark',
                      param: __props.message.seen ? 'seen' : '',
                      class: "vac-icon-check"
                    }, null, 8, ["name", "param"])
                  ])
                ]))
              : (
								__props.message.senderId === __props.currentUserId ||
								rightMessageOrigins.includes(__props.message.origin ?? '')
							)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                    _renderSlot(_ctx.$slots, "checkmark-icon", _normalizeProps(_guardReactiveProps({ message: __props.message })), () => [
                      _hoisted_10
                    ])
                  ]))
                : _createCommentVNode("", true)
          ]),
          _createVNode(MessageActions, {
            "current-user-id": __props.currentUserId,
            message: __props.message,
            "message-actions": __props.messageActions,
            "show-reaction-emojis": __props.showReactionEmojis,
            "message-hover": _unref(data).messageHover,
            "hover-message-id": _unref(data).hoverMessageId ?? undefined,
            "hover-audio-progress": _unref(data).hoverAudioProgress,
            onUpdateMessageHover: _cache[3] || (_cache[3] = ($event: any) => (_unref(data).messageHover = $event)),
            onUpdateOptionsOpened: _cache[4] || (_cache[4] = ($event: any) => (_unref(data).optionsOpened = $event)),
            onUpdateEmojiOpened: _cache[5] || (_cache[5] = ($event: any) => (_unref(data).emojiOpened = $event)),
            onMessageActionHandler: messageActionHandler,
            onSendMessageReaction: sendMessageReaction
          }, _createSlots({ _: 2 }, [
            _renderList(_ctx.$slots, (i, name) => {
              return {
                name: name,
                fn: _withCtx((_data) => [
                  _renderSlot(_ctx.$slots, name, _normalizeProps(_guardReactiveProps(_data)))
                ])
              }
            })
          ]), 1032, ["current-user-id", "message", "message-actions", "show-reaction-emojis", "message-hover", "hover-message-id", "hover-audio-progress"])
        ], 34),
        _createVNode(MessageReactions, {
          "current-user-id": __props.currentUserId,
          message: __props.message,
          onSendMessageReaction: sendMessageReaction
        }, null, 8, ["current-user-id", "message"])
      ], 2),
      _renderSlot(_ctx.$slots, "message-failure", _normalizeProps(_guardReactiveProps({ message: __props.message })), () => [
        (
						__props.message.failure &&
						(__props.message.senderId === __props.currentUserId ||
							rightMessageOrigins.includes(__props.message.origin ?? ''))
					)
          ? (_openBlock(), _createBlock(_component_el_tooltip, {
              key: 0,
              content: __props.message.failure,
              placement: "left"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(["vac-failure-container vac-svg-button", {
							'vac-failure-container-avatar':
								__props.message.avatar &&
								(__props.message.senderId === __props.currentUserId ||
									rightMessageOrigins.includes(__props.message.origin ?? '')),
						}]),
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('open-failed-message', { message: __props.message })))
                }, _hoisted_12, 2)
              ]),
              _: 1
            }, 8, ["content"]))
          : _createCommentVNode("", true)
      ]),
      (
					__props.message.avatar &&
					(__props.message.senderId === __props.currentUserId ||
						rightMessageOrigins.includes(__props.message.origin ?? ''))
				)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "vac-avatar vac-avatar-current",
            style: _normalizeStyle({ 'background-image': `url('${__props.message.avatar}')` })
          }, null, 4))
        : _createCommentVNode("", true),
      (_unref(hasCurrentUserAvatar) && !__props.message.avatar)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})